import { render, staticRenderFns } from "./GroupTotal.vue?vue&type=template&id=3622449a&scoped=true"
import script from "./GroupTotal.vue?vue&type=script&lang=js"
export * from "./GroupTotal.vue?vue&type=script&lang=js"
import style0 from "./GroupTotal.vue?vue&type=style&index=0&id=3622449a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3622449a",
  null
  
)

export default component.exports